<div class="row text-center text-lg-left image-thumb-gallery custom-image-thumb-gallery pl-0">
  @for (object of gridData; track object) {
    <div class="flex-cont gridItem visible position-relative custom-thumb-img-holder" id="{{object.objectKey}}">
      <div class="thumb-img-holder custom-img-holder" title="{{object.objectName}}" (click)="itemClicked(object)">
        @if (object.defaultThumbnailRequired) {
          <div class="grid_file_child default-thumbnail-icon custom-default-thumbnail-icon  {{object.defaultIconClassName}}" data-toggle="tooltip">
            @if (object.format == 'image') {
              @if(object.placeKey){
                <span class="NeueLocation no-img position-absolute"></span>
              }@else{
                <span class="{{object.iconName}} position-absolute"></span>
              }
            }
          </div>
        }
        @if ((universalService.mobileSelectionModeOn || !universalService.isMobileDevice) && showCheckBox) {
          <label class="check-wrap">
            <span class="checkmark thumb-checkmark"></span>
          </label>
        }
        <div class="grid_file_child grid_file_child_thumbnail grid-file-name-patch">
          <div class="position-absolute" style="display: flex;left: 0; top: 0px;">
            @if (object.format != 'image') {
              <span class="{{object.iconName}} icon-bg"></span>
            }
            @if (object?.isFavorite && showFavoriteIcon) {
              <span class="grid-top-icons NeueStarFilled" [ngClass]="[object.format == 'image' ? 'img-fav-icon-bg' : 'fav-icon-bg']"></span>
            }
            @if (object?.shareType && object.shareType == 'R' && object.isShared) {
              <span class="grid-top-icons img-share-icon-bg NeueDuplicates"></span>
            }
          </div>
          <span class="{{object.tileName}}"></span>
          @if (object.format == 'image' || object.format == 'video' || object.format == 'audio') {
            <!-- <img #lazyImage id="custom_grid_img{{object.objectKey}}" class="img-fluid img-thumbnail" loading="lazy" [attr.data-src]="object.imageTranscodeUrl" (error)="universalService.thumbnailError($event)" data-toggle="tooltip" alt="" /> -->
            <img id="custom_grid_img{{object.objectKey}}" class="img-fluid img-thumbnail" src="{{object.imageTranscodeUrl}}" (error)="universalService.thumbnailError($event)" data-toggle="tooltip" alt="" />
          }
        </div>
        @if (!universalService.mobileSelectionModeOn && showMoreOptionsIcon) {
          <span class="NeueMore_Options m-more-options" data-toggle="modal" data-target="#more-options-thumbnails-modal"></span>
        }
      </div>
      <!-- @if (showNameOnThumbnails && object.objectName != '') { -->
        <div class="thmbnailName custom-thmbnailName" title="{{object.objectName}}" (click)="itemClicked(object)" [ngClass]="(this.universalService.currentTab == 'Places') ? 'place-custom-thmbnailName' : ''">
          <span class="file_name">{{object.objectName}}</span>
        </div>
       <!-- } -->
    </div>
  }
</div>
